import { z } from 'zod';

export const workType = [
  { name: 'Annual Leave' },
  { name: "Personal/Carer's Leave" },
  { name: 'Leave without pay' },
  { name: 'Long Service Leave' },
  { name: 'School' },
  { name: 'Rostered Day Off' },
  { name: 'Public Holiday' }
];

export const scheduleSchema = z
  .object({
    date: z.string().min(1, 'Date is required'),
    site: z.string().optional(),
    workType: z.string().optional(),
    employees: z
      .array(
        z.object({
          value: z.string(),
          label: z.string()
        })
      )
      .min(1, 'Please select at least one employee'),
    startTime: z.string().min(1, 'Start time is required'),
    endTime: z.string().min(1, 'End time is required'),
    comments: z.string().optional()
  })
  .superRefine((data, ctx) => {
    if (!data.site && !data.workType) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Either Work Site or Leave Category must be selected',
        path: ['site']
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Either Work Site or Leave Category must be selected',
        path: ['workType']
      });
    }
  });
